<template>
  <v-container>
    <v-img :src="logogo" alt="logo" max-width="110px" class="resp" />
    <div justify="center" align="center" class="mt-16">
      <v-card class="loginCard pa-8 rounded-xl" elevation="20">
        <v-form ref="loginForm" @submit.prevent="submit">
          <v-card-title class="black--text mb-5"><h2>Sign in</h2></v-card-title>
          <v-text-field
            refs="email"
            outlined
            type="email"
            label="Email"
            v-model="email"
            color="#black"
            :rules="emailRules"
          ></v-text-field
          ><v-text-field
            class="black--text"
            refs="password"
            v-model="password"
            outlined
            label="Password"
            :type="show3 ? 'text' : 'password'"
            :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show3 = !show3"
            color="#black"
            :rules="[required]"
          ></v-text-field>
          <v-card-actions
            class="d-flex justify-center align center login"
            max-width="100%"
            ><v-btn
              class="white--text font-weight-bold mt-5"
              color="#494949"
              block
              max-width="100%"
              @click="submit"
              rounded
              height="60px"
              :disabled="loading"
            >
              <v-progress-circular
                v-if="loading"
                size="24"
                width="2"
                color="white"
                indeterminate
                absolute
              ></v-progress-circular>
              <span v-if="!loading">Login</span></v-btn
            ></v-card-actions
          ></v-form
        >
      </v-card>
    </div></v-container
  >
</template>

<script>
export default {
  name: "Login",
  data: () => ({
    logogo: require("@/assets/logotest.png"),
    // snackbar: false,
    loading: false,
    timeout: 3000,
    show3: false,
    email: "",
    password: "",
    required: (value) => !!value || "This field is required",
    emailRules: [
      (value) => !!value || "E-mail is required",
      (value) => /.+@.+\..+/.test(value) || "E-mail must be valid",
    ],
    emailError: "",
  }),
  methods: {
    submit() {
      // this.snackbar = true;
      if (this.$refs.loginForm.validate()) {
        console.log("submit");
      }
      this.$store.dispatch("loginForm", {
        email: this.email,
        password: this.password,
      });
      {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      }
    },
  },
};
</script>

<style scoped>
.loginCard {
  max-width: 100% !important;
  width: 483px !important;
  height: 456px !important;
  max-height: 100% !important;
}
.login {
  max-width: 100% !important;
}
h2 {
  color: #494949;
}
.v-text-field--outlined >>> fieldset {
  border-color: black;
}
</style>
